import {animate, onScroll, utils} from './anime.esm.js';

document.addEventListener('DOMContentLoaded', () => {
    const animationBlocks = document.querySelectorAll('.animate-block');
    const animationLogos = document.querySelectorAll('.animate-logo');
    const animateProductPresentations = document.querySelectorAll('.animate-product-presentation');
    const animateProducts = document.querySelectorAll('.animate-product');
    const animateScrollButtons = document.querySelectorAll('.animate-scroll-button');
    const animateBgImages = document.querySelectorAll('.animate-bg-image');
    const showButtons = document.querySelectorAll('.show-product-button');
    const closeButtons = document.querySelectorAll('.product-close');
    const endContent = document.querySelector('.animate-end-content');

    const viewportHeight = window.innerHeight;
    const offset = (viewportHeight / 2);
    const autoscrollDuration = parseInt(endContent?.dataset?.autoscrollDuration ?? 3);
    const windowsScrollTop = window.scrollY;
    let scrollAnimation = null;
    let scrollStopped = false;

    window.scrollTo(0, 0);

    animateScrollButtons.forEach(animateScrollButton => {
        animateScrollButton.addEventListener('click', () => {
            let target = animateScrollButton.closest('section').nextElementSibling;
            let tries = 0;
            while (!target.classList.contains('animate-section') && tries < 10) {
                target = target.nextElementSibling;
                tries++;
            }

            scrollInto(target).catch(() => console.error('Failed to scroll into target.'));
        })

    })

    if (animateScrollButtons.length === 0) {
        window.scrollTo(0, windowsScrollTop);
    }

    closeButtons.forEach(closeButton => {
        let overlay = closeButton.closest('.product-overlay');
        closeButton.addEventListener('click', () => {
            overlay.classList.remove('open');
            overlay.style.opacity = 0;
            overlay.style.pointerEvents = 'none';

            setTimeout(() => {
                overlay.style.display = 'none';
            }, 250)

            setTimeout(() => {
                overlay.style.opacity = null
                overlay.style.pointerEvents = null
                overlay.style.display = null
            }, 500);
        })
    })

    showButtons.forEach(showButton => {
        let overlay = showButton.parentElement.querySelector('.product-overlay');
        showButton.addEventListener('click', () => {
            overlay.classList.toggle('open');
        })
    })

    async function scrollInto(block) {
        const scrollOffsetElement = (window.innerWidth > 1024 ? block?.dataset?.scrollMobileOffset : null) ?? block?.dataset?.scrollOffset ?? 1;
        const scrollOffset = (viewportHeight * 0.50) * scrollOffsetElement;

        const targetHeight = block.clientHeight;
        const targetY = block.offsetTop + (targetHeight / 2) - scrollOffset;

        const scrollProxy = {y: window.scrollY};
        const duration = (targetY - scrollProxy.y) * autoscrollDuration;
        return animate(scrollProxy, {
            y: targetY,
            duration: Math.abs(duration),
            ease: 'linear',
            onUpdate: () => window.scrollTo(0, scrollProxy.y)
        });
    }

    function stopAutoScroll() {
        scrollStopped = true;
        scrollAnimation.stop();
    }

    async function initScrollStops() {
        if (window.scrollY !== 0) {
            return;
        }

        ['wheel', 'touchstart'].forEach(event => {
            window.addEventListener(event, stopAutoScroll, { passive: true, once: true });
        });

        const scrollStops = document.querySelectorAll('[data-stop="true"]');

        for (const scrollStop of scrollStops) {
            await new Promise(resolve => setTimeout(
                () => {
                    scrollAnimation = scrollInto(scrollStop);
                    scrollAnimation.finally(() => resolve())
                },
                500)
            );
            if (scrollStopped) {
                return;
            }
        }
    }

    setTimeout(() => initScrollStops(), 500);

    animationBlocks.forEach(animationBlock => {
        animate(animationBlock, {
            ease: 'linear',
            ...extraData(animationBlock),
            autoplay: onScroll({
                container: '.animate-template',
                enter: `bottom+=${offset + 80} top`,
                leave: `top+=${offset - 80} bottom`,
                sync: 0.5,
                debug: false,
            }),
        })
    })

    animationLogos.forEach(animationLogo => {
        animate(animationLogo, {
            ease: 'linear',
            ...extraData(animationLogo),
            autoplay: onScroll({
                container: '.animate-template',
                enter: `bottom+=${offset + 120} top`,
                leave: `top+=24 top`,
                sync: 0.5,
                debug: false,
                onEnterBackward: (self) => {
                    animationLogo.querySelector('.image-logo').style.transform = null;
                },
                onEnterForward: (self) => {
                    animationLogo.querySelector('.image-logo').style.transform = null;
                },
                onSyncComplete: (self) => {
                    animationLogo.querySelector('.image-logo').style.transform = 'scale(1)';
                }
            })
        })
    })

    animateProductPresentations.forEach(animateProductPresentation => {
        animate(animateProductPresentation, {
            ease: 'linear',
            ...extraData(animateProductPresentation),
            autoplay: onScroll({
                container: '.animate-template',
                enter: `top+=${offset} top`,
                leave: `bottom+=${offset} bottom`,
                sync: 0.5,
                debug: false,
            }),
        })
    })

    animateProducts.forEach(animateProduct => {
        const value = animateProduct.dataset.presentationHeight / 100 ?? 1
        animate(animateProduct, {
            ease: 'linear',
            ...extraData(animateProduct),
            autoplay: onScroll({
                container: '.animate-template',
                enter: `bottom+=${offset  * 2} top`,
                leave: `top+=${offset} bottom`,
                sync: true,
                debug: false,
            }),
        })
    })

    animateBgImages.forEach(animateBgImage => {
        let nextSibling = animateBgImage.nextElementSibling;
        let maxItems = 0
        let stopHeight = 0;
        while ((nextSibling.dataset.type === 'text' || nextSibling.dataset.type === 'logo') && nextSibling.dataset.prevImage === 'true') {
            maxItems++;
            const styles = window.getComputedStyle(nextSibling);
            stopHeight += (nextSibling.clientHeight + parseInt(styles.marginTop) + parseInt(styles.marginBottom));
            nextSibling = nextSibling.nextElementSibling;
            if (maxItems > 100) break;
        }

        let percentage = (120 / stopHeight) * 100;

        animate(animateBgImage, {
            ease: 'linear',
            "--opacity": [
                {from: 0, to: 1, duration: percentage * 0.5},
                {from: 1, to: 1, duration: 100 - percentage},
                {from: 1, to: 0, duration: percentage * 0.5},
            ],
            autoplay: onScroll({
                container: '.animate-template',
                enter: `bottom+=${offset + 80} top`,
                leave: `top+=${offset - stopHeight} bottom`,
                sync: true,
                debug: false,
            }),
        })
    })
})

function extraData(element) {
    let dataAnimation = {};
    switch (element.dataset.type) {
        case 'product':
            dataAnimation = generateProductData(element);
            break;
        case 'logo':
            dataAnimation = generateLogoData(element);
            break;
        case 'text':
            dataAnimation = generateTextData(element);
            break;
        case 'product-presentation':
            dataAnimation = generateProductPresentationData(element);
            break;
    }
    return dataAnimation;
}

function generateProductData(el) {
    let isLastOfType = !el.nextElementSibling || el.nextElementSibling.tagName !== el.tagName;

    let data = generateDefaultData();

    data["--pointer"] = [
            {from: "none", to: "none", duration: 5},
            {from: "auto", to: "auto", duration: 4},
            {from: "none", to: "none", duration: 1}
    ]

    data["--next-opacity"] = [
        {from: 0, to: 0, duration: 6},
        {from: 0, to: 1, duration: 0.5},
        {from: 1, to: 1, duration: 1},
        {from: 1, to: 0, duration: 0.5},
        {from: 0, to: 0, duration: 1.5}
    ]

    data["--next-pointer"] = [
        {from: "none", to: "none", duration: 6.5},
        {from: "auto", to: "auto", duration: 2},
        {from: "none", to: "none", duration: 1.5},
    ]

    data["--opacity"] = [
        {from: 0, to: 0, duration: 2.5},
        {from: 0, to: 1, duration: 2},
        {from: 1, to: 1, duration: 3.5},
        {from: 1, to: 0, duration: 1},
        {from: 0, to: 0, duration: 1}
    ]
    data["--translate-y"] = [
        {from: "3rem", to: "3rem", duration: 2.5},
        {from: "3rem", to: "0rem", duration: 4.5},
        {from: "0rem", to: "0rem", duration: 0},
        {from: "0rem", to: "-4rem", duration: 2.5},
        {from: "-4rem", to: "-4rem", duration: 0.5}
    ]

    data["--opacity-image"] = [
        {from: 0, to: 1, duration: 1.2},
        {from: 1, to: 1, duration: 7.6},
        {from: 1, to: 0, duration: 1.2}
    ]

    if (isLastOfType) {
        data["--next-opacity"] = [];
        data["--next-pointer"] = [];

        data["--position"] = [
            {from: "fixed", to: "fixed", duration: 6.7},
            {from: "absolute", to: "absolute", duration: 3.3},
        ];

        data["--translate-y"] = [
            {from: "3rem", to: "3rem", duration: 5},
            {from: "3rem", to: "0rem", duration: 1},
            {from: "0rem", to: "0rem", duration: 4},
        ];

        data["--opacity"] = [
            {from: 0, to: 0, duration: 5},
            {from: 0, to: 1, duration: 1},
            {from: 1, to: 1, duration: 4}
        ];

        data["--pointer"] = [
            {from: "none", to: "none", duration: 5},
            {from: "auto", to: "auto", duration: 5}
        ];

        data["--opacity-image"] = [
            {from: 0, to: 1, duration: 1.2},
            {from: 1, to: 1, duration: 8.8}
        ];
    }

    return data;
}

function generateLogoData(el) {
    const nextSibling = el.nextElementSibling;
    const prevSibling = el.previousElementSibling;
    let data = {
        ...generateDefaultData(),
        "--next-opacity": [
            {from: 0, to: 0, duration: 1.5},
            {from: 0, to: 1, duration: 0.3},
            {from: 1, to: 1, duration: 1},
            {from: 1, to: 0, duration: 0.2},
            {from: 0, to: 0, duration: 7}
        ],
        "--next-pointer": [
            {from: "none", to: "none", duration: 1.5},
            {from: "auto", to: "auto", duration: 1.5},
            {from: "none", to: "none", duration: 7},
        ],
        "--opacity": [
            {from: 0, to: 1, duration: 1.5},
            {from: 1, to: 1, duration: 1.5},
            {from: 1, to: 0, duration: 7}
        ],
        "--image-scale": [
            {from: 0, to: 3, duration: 1.5},
            {from: 3, to: 3, duration: 1.5},
            {from: 3, to: 1, duration: 7},
        ],
        "--opacity-image": [
            {from: 0, to: 1, duration: 1.2},
            {from: 1, to: 1, duration: 8.6},
            {from: 1, to: 0, duration: 1.2},
        ],
    }
    let prevOpacityImageStep = [{from: 0, to: 1, duration: 1.2}];
    let afterOpacityImageStep = [{from: 1, to: 0, duration: 1.2}];

    if ((nextSibling?.dataset?.type === 'text' || nextSibling?.dataset?.type === 'logo') && nextSibling.dataset.prevImage === 'true') {
        afterOpacityImageStep = [
            {from: 1, to: 0, duration: 0},
            {from: 0, to: 0, duration: 0.8},
        ]
    }

    if ((prevSibling?.dataset?.type === 'text' || prevSibling?.dataset?.type === 'logo') && el.dataset.prevImage === 'true') {
        prevOpacityImageStep = [
            {from: 0, to: 1, duration: 0},
            {from: 1, to: 1, duration: 1.2},
        ]
    }

    data["--opacity-image"] = [
        ...prevOpacityImageStep,
        {from: 1, to: 1, duration: 9},
        ...afterOpacityImageStep,
    ];
    return data;
}

function generateTextData(el) {
    const nextSibling = el.nextElementSibling;
    const prevSibling = el.previousElementSibling;
    let data = {
        ...generateDefaultData(),
        "--next-opacity": [
            {from: 0, to: 0, duration: 3.3},
            {from: 0, to: 1, duration: 0.5},
            {from: 1, to: 1, duration: 2.3},
            {from: 1, to: 0, duration: 0.5},
            {from: 0, to: 0, duration: 3.3}
        ],
        "--next-pointer": [
            {from: "none", to: "none", duration: 3.3},
            {from: "auto", to: "auto", duration: 3.3},
            {from: "none", to: "none", duration: 3.3},
        ],
        "--opacity": [
            {from: 0, to: 1, duration: 3.3},
            {from: 1, to: 1, duration: 3.3},
            {from: 1, to: 0, duration: 3.3}
        ],
        "--text-opacity": [
            {from: 0, to: 1, duration: 3.3},
            {from: 1, to: 1, duration: 3.3},
            {from: 1, to: 0, duration: 3.3}
        ],
    }
    let prevOpacityImageStep = [{from: 0, to: 1, duration: 1.2}];
    let afterOpacityImageStep = [{from: 1, to: 0, duration: 1.2}];

    if ((nextSibling?.dataset?.type === 'text' || nextSibling?.dataset?.type === 'logo') && nextSibling.dataset.prevImage === 'true') {
        afterOpacityImageStep = [
            {from: 1, to: 0, duration: 0},
            {from: 0, to: 0, duration: 3.3},
        ]
    }

    if ((prevSibling?.dataset?.type === 'text' || prevSibling?.dataset?.type === 'logo') && el.dataset.prevImage === 'true') {
        prevOpacityImageStep = [
            {from: 0, to: 1, duration: 0},
            {from: 1, to: 1, duration: 3.3},
        ]
    }

    data["--opacity-image"] = [
        ...prevOpacityImageStep,
        {from: 1, to: 1, duration: 3.3},
        ...afterOpacityImageStep,
    ];

    return data;
}

function generateProductPresentationData(el) {
    const defaultOptions = {
        "presentation_image_scale_start": 0.2,
        "presentation_image_scale": 1,
        "presentation_image_mobile_scale": 1,
        "presentation_image_scale_end": 0.5,
        "presentation_image_mobile_scale_end": 0.5,
        "enable_shape": false,
        "presentation_shape_type": "ellipse",
        "presentation_shape_origin_x": 0,
        "presentation_shape_origin_y": 0,
        "presentation_shape_exit_x": 0,
        "presentation_shape_exit_y": 0,
        "presentation_shape_mobile_exit_x": 0,
        "presentation_shape_mobile_exit_y": 0,
        "presentation_shape_destination_x": 0,
        "presentation_shape_destination_y": 0,
        "presentation_shape_mobile_destination_x": 0,
        "presentation_shape_mobile_destination_y": 0,
        "presentation_shape_product_shape_position_x": 35,
        "presentation_shape_product_shape_position_y": 47,
        "presentation_shape_scale_start": 1,
        "presentation_shape_scale": 1,
        "presentation_shape_mobile_scale": 1,
        "presentation_shape_scale_end": 0,
        "presentation_shape_mobile_scale_end": 0,
        "presentation_image_origin_x": 0,
        "presentation_image_origin_y": 0,
        "presentation_image_exit_x": 0,
        "presentation_image_exit_y": 0,
        "presentation_image_mobile_exit_x": 0,
        "presentation_image_mobile_exit_y": 0,
        "presentation_image_destination_x": 0,
        "presentation_image_destination_y": 0,
        "presentation_image_mobile_destination_x": 0,
        "presentation_image_mobile_destination_y": 0,
        "presentation_product_shape_position_x": 35,
        "presentation_product_shape_position_y": 47,
        "presentation_shape_color": null,
    }

    const options = { ...defaultOptions, ...JSON.parse(el.dataset.options ?? '{}') };
    if (options.presentation_shape_color === "rgba(0,0,0,0)" || options.presentation_shape_color === "#0000" || options.presentation_shape_color === "#00000000") {
        options.presentation_shape_color = null;
    }

    let image_scale = options.presentation_image_scale;
    let image_scale_end = options.presentation_image_scale_end;
    let destination_x = options.presentation_image_destination_x;
    let destination_y = options.presentation_image_destination_y;
    let exit_x = options.presentation_image_exit_x;
    let exit_y = options.presentation_image_exit_y;

    if (window.innerWidth < 1024) {
        image_scale = options.presentation_image_mobile_scale;
        image_scale_end = options.presentation_image_mobile_scale_end;
        destination_x = options.presentation_image_mobile_destination_x;
        destination_y = options.presentation_image_mobile_destination_y;
        exit_x = options.presentation_image_mobile_exit_x;
        exit_y = options.presentation_image_mobile_exit_y;
    }

    let productData = {
        ...generateDefaultData(),
        "--next-opacity": [
            {from: 0, to: 0, duration: 4.5},
            {from: 0, to: 1, duration: 0.5},
            {from: 1, to: 1, duration: 1},
            {from: 1, to: 0, duration: 0.5},
            {from: 0, to: 0, duration: 3.5}
        ],
        "--next-pointer": [
            {from: "none", to: "none", duration: 4},
            {from: "auto", to: "auto", duration: 2},
            {from: "none", to: "none", duration: 4},
        ],
        "--scale": [
            {from: options.presentation_image_scale_start, to: image_scale, duration: 4},
            {from: image_scale, to: image_scale, duration: 2.5},
            {from: image_scale, to: image_scale_end, duration: 3.5}
        ],
        "--opacity": [
            {from: 0, to: 1, duration: 4},
            {from: 1, to: 1, duration: 2.5},
            {from: 1, to: 0, duration: 3.5}
        ],
        "--text-opacity": [
            {from: 0, to: 0, duration: 4.2},
            {from: 0, to: 1, duration: 0.8},
            {from: 1, to: 1, duration: 0},
            {from: 1, to: 0, duration: 3},
            {from: 0, to: 0, duration: 2}
        ],
        "--text-translate-y": [
            {from: "50%", to: "50%", duration: 4.2},
            {from: "50%", to: "-50%", duration: 0.8},
            {from: "-50%", to: "-50%", duration: 0},
            {from: "-50%", to: "-150%", duration: 3},
            {from: "-150%", to: "-150%", duration: 2}
        ],
        "--image-position-x": [
            {from: `${options.presentation_image_origin_x}%`, to: `${destination_x}%`, duration: 4},
            {from: `${destination_x}%`, to: `${destination_x}%`, duration: 2.5},
            {from: `${destination_x}%`, to: `${exit_x}%`, duration: 3.5}
        ],
        "--image-position-y": [
            {from: `${options.presentation_image_origin_y}%`, to: `${destination_y}%`, duration: 4},
            {from: `${destination_y}%`, to: `${destination_y}%`, duration: 2.5},
            {from: `${destination_y}%`, to: `${exit_y}%`, duration: 3.5}
        ]
    };


    if (options.enable_shape) {
        let productImage = document.querySelector(`#${el.dataset.productId} .animate-image img`);
        let rect = productImage.getBoundingClientRect();
        let imageTop = rect.top;
        let imageLeft = rect.left;

        imageTop = imageTop + (rect.height * (options.presentation_product_shape_position_y / 100));
        imageLeft = imageLeft + (rect.width * (options.presentation_product_shape_position_x / 100));

        productData["--text-scale"] = [
            {from: 1, to: 1, duration: 10}
        ]

        productData["--container-opacity"] = [
            {from: 1, to: 1, duration: 8.5},
            {from: 1, to: 0, duration: 1.5}
        ]

        productData["--text-opacity"] = [
            {from: 0, to: 0, duration: 4},
            {from: 0, to: 1, duration: 1},
            {from: 1, to: 1, duration: 0},
            {from: 1, to: 0, duration: 1},
            {from: 0, to: 0, duration: 4}
        ]

        productData["--text-translate-y"] = [
            {from: "-50%", to: "-50%", duration: 5.5},
            {from: "-50%", to: "-150%", duration: 1},
            {from: "-150%", to: "-150%", duration: 3}
        ]

        productData["--container-scale"] = [
            {from: 1, to: 1, duration: 6},
            {from: 1, to: 0, duration: 4}
        ]

        productData["--container-top"] = [
            {from: '0px', to: '0px', duration: 6},
            {from: '0px', to: `${imageTop}px`, duration: 4}
        ]

        productData["--container-left"] = [
            {from: '0px', to: '0px', duration: 6},
            {from: '0px', to: `${imageLeft}px`, duration: 4}
        ]

        productData["--scale"] = [
            {from: options.presentation_image_scale_start, to: image_scale, duration: 4},
            {from: image_scale, to: image_scale, duration: 2},
            {from: image_scale, to: image_scale_end, duration: 0.5},
            {from: image_scale_end, to: image_scale_end, duration: 3.5}
        ]

        productData["--opacity"] = [
            {from: 0, to: 1, duration: 5},
            {from: 1, to: 1, duration: 5}
        ]

        productData["--position"] = [
            {from: 0, to: 0, duration: 6},
            {from: 0, to: 0, duration: 0.5},
            {from: 1, to: 1, duration: 3.5}
        ]
        productData["--image-position-x"] = [
            {from: `${options.presentation_image_origin_x}%`, to: `${destination_x}%`, duration: 4},
            {from: `${destination_x}%`, to: `${destination_x}%`, duration: 2},
            {from: `${destination_x}%`, to: `${exit_x}%`, duration: 0.5},
            {from: `${exit_x}%`, to: `${exit_x}%`, duration: 3.5}
        ]

        productData["--image-position-y"] = [
            {from: `${options.presentation_image_origin_y}%`, to: `${destination_y}%`, duration: 4},
            {from: `${destination_y}%`, to: `${destination_y}%`, duration: 2},
            {from: `${destination_y}%`, to: `${exit_y}%`, duration: 0.5},
            {from: `${exit_y}%`, to: `${exit_y}%`, duration: 3.5}
        ]

        if (options.presentation_shape_color) {
            let shape_scale = options.presentation_shape_scale;
            let shape_scale_end = options.presentation_shape_scale_end;
            let shape_destination_x = options.presentation_shape_destination_x;
            let shape_destination_y = options.presentation_shape_destination_y;
            let shape_exit_x = options.presentation_shape_exit_x;
            let shape_exit_y = options.presentation_shape_exit_y;

            if (window.innerWidth < 1024) {
                shape_scale = options.presentation_shape_mobile_scale;
                shape_scale_end = options.presentation_shape_mobile_scale_end;
                shape_destination_x = options.presentation_shape_mobile_destination_x;
                shape_destination_y = options.presentation_shape_mobile_destination_y;
                shape_exit_x = options.presentation_shape_mobile_exit_x;
                shape_exit_y = options.presentation_shape_mobile_exit_y;
            }

            productData["--text-opacity"] = [
                {from: 0, to: 0, duration: 4},
                {from: 0, to: 1, duration: 1},
                {from: 1, to: 1, duration: 2},
                {from: 1, to: 0, duration: 1},
                {from: 0, to: 0, duration: 3}
            ]

            productData["--text-translate-y"] = [
                {from: "-50%", to: "-50%", duration: 7.5},
                {from: "-50%", to: "-150%", duration: 1},
                {from: "-150%", to: "-150%", duration: 3}
            ]

            productData["--scale"] = [
                {from: options.presentation_image_scale_start, to: image_scale, duration: 4},
                {from: image_scale, to: image_scale, duration: 2},
                {from: image_scale, to: image_scale_end, duration: 1.5},
                {from: image_scale_end, to: image_scale_end, duration: 2.5}
            ]

            productData["--container-scale"] = [
                {from: 1, to: 1, duration: 7.5},
                {from: 1, to: 0, duration: 2.5}
            ]

            productData["--container-top"] = [
                {from: '0px', to: '0px', duration: 7.5},
                {from: '0px', to: `${imageTop}px`, duration: 2.5}
            ]

            productData["--container-left"] = [
                {from: '0px', to: '0px', duration: 7.5},
                {from: '0px', to: `${imageLeft}px`, duration: 2.5}
            ]

            productData["--image-position-x"] = [
                {from: `${options.presentation_image_origin_x}%`, to: `${destination_x}%`, duration: 4},
                {from: `${destination_x}%`, to: `${destination_x}%`, duration: 2},
                {from: `${destination_x}%`, to: `${exit_x}%`, duration: 1.5},
                {from: `${exit_x}%`, to: `${exit_x}%`, duration: 2.5}
            ]

            productData["--image-position-y"] = [
                {from: `${options.presentation_image_origin_y}%`, to: `${destination_y}%`, duration: 4},
                {from: `${destination_y}%`, to: `${destination_y}%`, duration: 2},
                {from: `${destination_y}%`, to: `${exit_y}%`, duration: 1.5},
                {from: `${exit_y}%`, to: `${exit_y}%`, duration: 2.5}
            ]

            productData["--shape-opacity"] = [
                {from: 0, to: 0, duration: 3.5},
                {from: 0, to: 1, duration: 1},
                {from: 1, to: 1, duration: 5.5}
            ]

            productData["--shape-after-opacity"] = [
                {from: 0, to: 0, duration: 6},
                {from: 0, to: 1, duration: 1.5},
                {from: 1, to: 1, duration: 2.5}
            ]

            productData["--shape-color"] = [
                {from: el.dataset.shapeColor, to: el.dataset.shapeColor, duration: 6},
                {from: el.dataset.shapeColor, to: "#ffffff", duration: 1.5},
                {from: "#ffffff", to: "#ffffff", duration: 2.5}
            ]

            productData["--grayscale"] = [
                {from: 0, to: 0, duration: 6},
                {from: 0, to: 1, duration: 1},
                {from: 1, to: 1, duration: 3}
            ]

            productData["--shape-scale"] = [
                {from: options.presentation_shape_scale_start, to: options.presentation_shape_scale_start, duration: 3.5},
                {from: options.presentation_shape_scale_start, to: shape_scale, duration: 2.2},
                {from: shape_scale, to: shape_scale, duration: 0.1},
                {from: shape_scale, to: shape_scale_end, duration: 1.7},
                {from: shape_scale_end, to: shape_scale_end, duration: 2.5}
            ]

            productData["--shape-position-x"] = [
                {from: `${options.presentation_shape_origin_x}%`, to: `${options.presentation_shape_origin_x}%`, duration: 3.5},
                {from: `${options.presentation_shape_origin_x}%`, to: `${shape_destination_x}%`, duration: 2},
                {from: `${shape_destination_x}%`, to: `${shape_destination_x}%`, duration: 0.5},
                {from: `${shape_destination_x}%`, to: `${shape_exit_x}%`, duration: 1.5},
                {from: `${shape_exit_x}%`, to: `${shape_exit_x}%`, duration: 2.5}
            ]

            productData["--shape-position-y"] = [
                {from: `${options.presentation_shape_origin_y}%`, to: `${options.presentation_shape_origin_y}%`, duration: 3.5},
                {from: `${options.presentation_shape_origin_y}%`, to: `${shape_destination_y}%`, duration: 2},
                {from: `${shape_destination_y}%`, to: `${shape_destination_y}%`, duration: 0.5},
                {from: `${shape_destination_y}%`, to: `${shape_exit_y}%`, duration: 1.5},
                {from: `${shape_exit_y}%`, to: `${shape_exit_y}%`, duration: 2.5}
            ]

            let shapeCalcText = '50cqw * 7 / 12';
            if (options.presentation_shape_type == 'circle') {
                shapeCalcText = '50cqw';
                let aspectRatio = window.innerWidth / window.innerHeight;

                productData["--clip-rx"] = [
                    {from: '200', to: '200', duration: 7.5},
                    {from: `calc(50cqw * ${shape_scale_end})`, to: `calc(50cqw * ${shape_scale_end})`, duration: 2.5}
                ]

                productData["--clip-ry"] = [
                    {from: 200, to: 200, duration: 7.5},
                    {
                        from: `calc((${shapeCalcText}) * ${shape_scale_end})`,
                        to: `calc(${shapeCalcText} * ${shape_scale_end})`,
                        duration: 2.5
                    }
                ]

                productData["--clip-cx"] = [
                    {from: 50, to: 50, duration: 7.5},
                    {from: `calc(${shape_exit_x}% + 50cqw)`, to: `calc(${shape_exit_x}% + 50cqw)`, duration: 2.5}
                ]

                productData["--clip-cy"] = [
                    {from: 50, to: 50, duration: 7.5},
                    {
                        from: `calc(${shape_exit_y}% + (50 * (${aspectRatio}) * 1cqh))`,
                        to: `calc(${shape_exit_y}% + (50 * (${aspectRatio}) * 1cqh))`,
                        duration: 2.5
                    }
                ]
            }
        }
    }

    return productData;
}

function generateDefaultData() {
    return {
        pointerEvents: [
            {from: "none", to: "none", duration: 0.5},
            {from: "auto", to: "auto", duration: 9},
            {from: "none", to: "none", duration: 0.5},
        ]
    }
}

function redistribute(arr, percent = 1) {
    if (arr.length < 2) return arr;

    return arr;
}